import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Moderator.css";
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';
import withMenuPermission from "../../../widgets/withMenuPermission";
import EnhancedTable from '../../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../../widgets/Toolbar';
import LinkDialog from "../../LinkDialog";
import OnlineModeratorScopeUS from './OnlineModeratorScopeUS';


const utils = new ViewUtils();
const linkToolbarRef = React.createRef();

const topToolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'viewScopeUS', label: '', tooltip: 'View unit standards linked to skills programme', icon: 'ViewIcon', disabled: true }
            ]
        }
    ]
};

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to unit standard scope', theme: true },
                { id: 'next', label: 'NEXT', tooltip: 'Proceed to uploaded documents', theme: true }
            ]
        }
    ]
};

const headCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme Code' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' }
];

class OnlineModeratorApprovalSkillsProgrammeScope extends Component {

    constructor(props) {
        super(props)

        this.state = {
            searchParameters: [{ Name: `OnlineModeratorAppID`, Value: this.props.location.state.selection }],
            SPScope: null,
            linkDialogUSOpen: false,
            selectedRowID: null
        }
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineModeratorApprovalDocuments',
                state: {
                    selection: this.props.location.state.selection,
                    QualScopeSelection: this.props.location.state.QualScopeSelection,
                    USScopeSelection: this.props.location.state.USScopeSelection,
                    SPScopeSelection: this.state.SPScope
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineModeratorApprovalUnitStandardScope',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ SPScope: selection });
            if (selection.length === 1) {
                this.setState({ selectedRowID: selection[0].QualificationID });
                linkToolbarRef.current.setButtonDisabled("viewScopeUS", false);
            }
            else {
                linkToolbarRef.current.setButtonDisabled("viewScopeUS", true);
            }
        } else {
            this.setState({ SPScope: null, selectedRowID: null });
            linkToolbarRef.current.setButtonDisabled("viewScopeUS", true);
        }
    };

    handleTopToolbarButtonClick = (buttonId) => {
        if (buttonId === "viewScopeUS") {
            this.setState({ linkDialogUSOpen: true })
        }
    };

    closeUSScope(isCancel, linked) {
        this.setState({ linkDialogUSOpen: false })
    }

    render() {
        return (
            <ViewContainer title="">
                <p className="breadcrumbs">
                    {"Moderator Approval > Skills Programme Scope"}
                </p>

                <EnhancedToolbar
                    highlight={false}
                    ref={linkToolbarRef}
                    buttonClickHandler={(buttonId) => this.handleTopToolbarButtonClick(buttonId)}
                    config={topToolbarConfig}
                />

                <br></br>
                <EnhancedTable multiSelect={true} autoFetchData={true} headCells={headCells} searchParameters={this.state.searchParameters} paged={false}
                    dataUrl="api/sims/OnlineModeratorApproval/GetSkillsProgrammeScope" onSelectionChange={this.handleSelectionChange} 
                />

                <LinkDialog open={this.state.linkDialogUSOpen} closeHandler={(isCancelled, linked) => this.closeUSScope(isCancelled, linked)}
                    dialogTitle={`Unit standards linked to Skills Programme`}
                >
                    <OnlineModeratorScopeUS IsExternal={this.props.IsExternal} ScopeType="SP" dataUrl="api/sims/OnlineAssessorRegistration/GetSearchScopeInterventionUS"
                        Id={this.state.selectedRowID} />
                </LinkDialog>

                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)} config={lowertoolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(OnlineModeratorApprovalSkillsProgrammeScope));

